import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';

import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-affiliation',
  templateUrl: './modal-affiliation.component.html',
  styleUrls: ['./modal-affiliation.component.scss']
})
export class ModalAffiliationComponent implements OnInit {

  @Input() projectId: number;

  public affiliationForm: FormGroup;
  public submitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private toast: ToastrService) { }

  ngOnInit() {
    this.affiliationForm = this.formBuilder.group({
      knowledge_area: ['', [Validators.required]],
      question_type: ['', [Validators.required]]
    });
  }

  public save(): void {
    this.submitted = true;

    if (this.affiliationForm.invalid) {
      return;
    }

    const formData: any = this.affiliationForm.value;

  }

  private errorHandler = (e: HttpErrorResponse) => {
    for (const key in e.error.errors) {
      this.toast.error(e.error.errors[key]);
    }
  }

}
